import { Page, View, Text, Image, Font } from "@react-pdf/renderer";
import { styles } from "./MemberDetailsStyle";
import FirstRow from "./Rows/FirstRow";
import { SecondRow } from "./Rows/SecondRow";
import ThirdRow from "./Rows/ThirdRow";

Font.register({
  family: "Roboto",
  src: "/fonts/roboto-pdf.ttf",
});

export function MemberDetailsPage({ item, translate, generationDateString }) {
  return (
    <Page size="A4" style={styles.page} id={`${item.hash}`} break>
      <View style={styles.logoContainer}>
        <Image src={"/images/sia-logo-claim.png"} style={styles.logo} />
      </View>
      <FirstRow item={item} translate={translate} />
      <SecondRow item={item} translate={translate} />
      <View>
        <Text style={styles.thirdRow.title}>{translate("directory.filter.expert.label")}</Text>
      </View>
      <ThirdRow item={item} translate={translate} />
      <View wrap={false}>
        <Text style={{ ...styles.thirdRow.right.statment_title, ...styles.marginTop }}>{translate("directory.member.info.label.statement")}</Text>
        <Text wrap={false}>{item.specialisation_details.statment}</Text>
      </View>
      <View style={styles.footer} fixed>
        <Text>{generationDateString}</Text>
      </View>
    </Page>
  );
}
